import React from 'react';
import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { dropdown } from './styles.module.css';

const DropDown = ({ className, onClose, children }) => {
  // Handler for react-onclickoutside
  DropDown.handleClickOutside = onClose;

  return <div className={classnames(dropdown, className)}>{children}</div>;
};

const clickOutsideConfig = {
  handleClickOutside: () => DropDown.handleClickOutside,
};

export default onClickOutside(DropDown, clickOutsideConfig);
